module.exports = __webpack_public_path__ + "img/image27.8bab2993.png";